import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MultipleGroupeSelect from './MultipleGroupeSelect';
import { fetchGroupes } from 'store/groupe/groupeActions';

class MultipleGroupeSelectContainer extends React.Component {
    componentDidMount() {
        this.props.fetchGroupes();
    }



    render() {
        const { groupes, selected, isLoading, onChange, size } = this.props;

        return (
            <MultipleGroupeSelect groupes={groupes}
                selected={selected}
                isLoading={isLoading}
                onChange={onChange}
                size={size}
            />
        );
    }
}

const mapStateToProps = state => ({
    groupes: state.groupe.groupes.items,
    isLoading: state.groupe.groupes.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchGroupes: () => dispatch(fetchGroupes())
});

MultipleGroupeSelectContainer.propTypes = {
    selected: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    size: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(MultipleGroupeSelectContainer);